var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchBoxMap",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"mapAdd"}}),_c('location-lengd',{ref:"LocationLengd"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }